import React from 'react';
import Layout from './components/Layout';
import Header from './components/Header';
import styles from './Typography.module.css';

const TypeExample = ({ className, children }) => (
  <div className={styles.typeExample}>
    <div className={styles.preview}>
      <span className={className}>{children}</span>
    </div>
    <div className={styles.details}>
      <span className={styles.className}>.{className}</span>
      <span className={styles.content}>{children}</span>
    </div>
  </div>
);

const Typography = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <Header 
          title="타이포그래피"
          description="PDS의 타이포그래피 시스템입니다. 일관된 타이포그래피로 제품의 정체성을 표현합니다."
        />

        <section className={styles.section}>
          <h2>제목 (Heading)</h2>
          <div className={styles.examples}>
            <TypeExample className="h1">존중하고 격려하며 함께 즐겨요. / Heading 1</TypeExample>
            <TypeExample className="h2">존중하고 격려하며 함께 즐겨요. / Heading 2</TypeExample>
            <TypeExample className="h3">존중하고 격려하며 함께 즐겨요. / Heading 3</TypeExample>
            <TypeExample className="h4">존중하고 격려하며 함께 즐겨요. / Heading 4</TypeExample>
            <TypeExample className="h5">존중하고 격려하며 함께 즐겨요. / Heading 5</TypeExample>
          </div>
        </section>

        <section className={styles.section}>
          <h2>목록 제목 (List Title)</h2>
          <div className={styles.examples}>
            <TypeExample className="list-title-1">존중하고 격려하며 함께 즐겨요. / List Title 1</TypeExample>
            <TypeExample className="list-title-2">존중하고 격려하며 함께 즐겨요. / List Title 2</TypeExample>
            <TypeExample className="list-title-3">존중하고 격려하며 함께 즐겨요. / List Title 3</TypeExample>
          </div>
        </section>

        <section className={styles.section}>
          <h2>본문 (Body)</h2>
          <div className={styles.examples}>
            <TypeExample className="body-1">존중하고 격려하며 함께 즐겨요. / Body 1</TypeExample>
            <TypeExample className="body-2">존중하고 격려하며 함께 즐겨요. / Body 2</TypeExample>
            <TypeExample className="body-3">존중하고 격려하며 함께 즐겨요. / Body 3</TypeExample>
            <TypeExample className="body-4">존중하고 격려하며 함께 즐겨요. / Body 4</TypeExample>
          </div>
        </section>

        <section className={styles.section}>
          <h2>레이블 (Label)</h2>
          <div className={styles.examples}>
            <TypeExample className="label-1">존중하고 격려하며 함께 즐겨요. / Label 1</TypeExample>
            <TypeExample className="label-2">존중하고 격려하며 함께 즐겨요. / Label 2</TypeExample>
            <TypeExample className="label-3">존중하고 격려하며 함께 즐겨요. / Label 3</TypeExample>
            <TypeExample className="label-4">존중하고 격려하며 함께 즐겨요. / Label 4</TypeExample>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default Typography; 